"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permit = exports.permitCaslState = exports.permitState = void 0;
const axios_1 = require("axios");
// Permit State
let permitLocalState = {};
exports.permitCaslState = [];
let isInitialized = false;
const getBulkPermissionFromBE = (url, user, actionsResourcesList, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = actionsResourcesList.map(({ action, resource, userAttributes = {}, resourceAttributes = {} }) => ({
        action,
        resource: typeof resource === 'string' ? resource : `${resource.type}:${resource.key}`,
        userAttributes,
        resourceAttributes,
    }));
    const config = headers ? { headers } : {};
    const response = yield axios_1.default.post(`${url}?user=${user}`, { resourcesAndActions: payload }, config);
    return response.data.permittedList;
});
const getPermissionFromBE = (url, user, action, resource, defaultPermission, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const config = headers ? { headers } : {};
    return yield axios_1.default
        .get(`${url}?user=${user}&action=${action}&resource=${resource}`, config)
        .then((response) => {
        return response.data.permitted;
    })
        .catch((error) => {
        if (error.response.status === 403) {
            return false;
        }
        // tslint:disable-next-line:no-console
        console.error(error);
        return defaultPermission;
    });
});
const generateStateKey = (action, resource, resourceAttributes = {}) => {
    const sortedResourceAttributeKeys = Object.keys(resourceAttributes).sort();
    const sortedResourceAttributes = sortedResourceAttributeKeys.reduce((obj, key) => {
        obj[key] = resourceAttributes[key];
        return obj;
    }, {});
    const hasResourceAttributes = sortedResourceAttributeKeys.length > 0;
    const userAttributeKey = `;userAttributes:${JSON.stringify(exports.permitState.userAttributes)}`;
    const resourceAttributeKey = hasResourceAttributes ? `;resourceAttributes:${JSON.stringify(sortedResourceAttributes)}` : '';
    const resourceKey = typeof resource === 'string' ? resource : `${resource.type}:${resource.key}`;
    return `user:${userAttributeKey};action:${action};resource:${resourceKey}${resourceAttributeKey}`;
};
const Permit = ({ loggedInUser, userAttributes = {}, backendUrl, defaultAnswerIfNotExist = false, customRequestHeaders }) => {
    if (!loggedInUser) {
        throw new Error('loggedInUser is required');
    }
    if (!backendUrl || typeof backendUrl !== 'string') {
        throw new Error('backendUrl is required, put your backend check url here');
    }
    const updatePermissionState = (actionResource, permission) => __awaiter(void 0, void 0, void 0, function* () {
        const { action, resource, resourceAttributes = {} } = actionResource;
        const key = generateStateKey(action, resource, resourceAttributes);
        permitLocalState[key] = permission;
        exports.permitCaslState.push({
            action,
            subject: typeof resource === 'string' ? resource : `${resource.type}:${resource.key}`,
            inverted: !permission,
        });
    });
    const loadLocalState = (actionsResourcesList) => __awaiter(void 0, void 0, void 0, function* () {
        if (isInitialized)
            return;
        isInitialized = true;
        for (const actionResource of actionsResourcesList) {
            const resourceKey = typeof actionResource.resource === 'string' ? actionResource.resource : `${actionResource.resource.type}:${actionResource.resource.key}`;
            const permission = yield getPermissionFromBE(backendUrl, loggedInUser, actionResource.action, resourceKey, defaultAnswerIfNotExist, customRequestHeaders);
            yield updatePermissionState(actionResource, permission);
        }
    });
    const loadLocalStateBulk = (actionsResourcesList) => __awaiter(void 0, void 0, void 0, function* () {
        if (isInitialized)
            return;
        isInitialized = true;
        const permittedList = yield getBulkPermissionFromBE(backendUrl, loggedInUser, actionsResourcesList, customRequestHeaders);
        for (const [i, actionResource] of actionsResourcesList.entries()) {
            yield updatePermissionState(actionResource, permittedList[i]);
        }
    });
    const getCaslJson = () => {
        return exports.permitCaslState;
    };
    const check = (action, resource, resourceAttributes = {}) => {
        var _a;
        const key = generateStateKey(action, resource, resourceAttributes);
        return (_a = permitLocalState[key]) !== null && _a !== void 0 ? _a : defaultAnswerIfNotExist;
    };
    const addKeyToState = (action, resource, resourceAttributes = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const resourceKey = typeof resource === 'string' ? resource : `${resource.type}:${resource.key}`;
        const permission = yield getPermissionFromBE(backendUrl, loggedInUser, action, resourceKey, defaultAnswerIfNotExist, customRequestHeaders);
        yield updatePermissionState({ action, resource, userAttributes: exports.permitState.userAttributes, resourceAttributes }, permission);
    });
    const reset = () => {
        permitLocalState = {};
        exports.permitCaslState = [];
        isInitialized = false;
    };
    exports.permitState = {
        addKeyToState,
        loadLocalState,
        loadLocalStateBulk,
        loggedInUser,
        backendUrl,
        defaultAnswerIfNotExist,
        state: permitLocalState,
        userAttributes,
        check,
        getCaslJson,
        reset,
    };
    return exports.permitState;
};
exports.Permit = Permit;
